import { cloneElement, useRef, forwardRef } from 'react'
import { useOverlayTriggerState } from '@react-stately/overlays'
import {
  useOverlay,
  useOverlayTrigger,
  useOverlayPosition,
  useModal,
  OverlayContainer,
} from '@react-aria/overlays'
import { useDialog } from '@react-aria/dialog'
import { FocusScope } from '@react-aria/focus'
import { useIsSSR } from '@react-aria/ssr'
import { mergeProps } from '@react-aria/utils'

const Popover = forwardRef(
  ({ isVisible, children, onClose, contentProps, state }, ref) => {
    const { overlayProps } = useOverlay(
      { isOpen: isVisible, onClose, isDismissable: true },
      ref
    )

    const { modalProps } = useModal()
    const { dialogProps, titleProps } = useDialog({}, ref)

    return (
      <FocusScope restoreFocus contain autoFocus>
        <div
          {...mergeProps(overlayProps, dialogProps, contentProps, modalProps)}
          ref={ref}
        >
          {typeof children === 'function'
            ? children({ titleProps, ...state })
            : children || null}
        </div>
      </FocusScope>
    )
  }
)

function PopoverContainer(props) {
  const isSSR = useIsSSR()

  let triggerRef = useRef()
  let overlayRef = useRef()

  const state = useOverlayTriggerState({})

  let { triggerProps, overlayProps } = useOverlayTrigger(
    { type: 'dialog' },
    state,
    triggerRef
  )

  let { overlayProps: positionProps } = useOverlayPosition({
    targetRef: triggerRef,
    overlayRef,
    placement: props.placement || 'bottom left',
    offset: 5,
    isOpen: state.isOpen,
  })

  return (
    <>
      {props.trigger
        ? cloneElement(
            props.trigger,
            mergeProps(props.trigger.props, triggerProps, {
              ref: triggerRef,
              onClick: () => state.open(),
            })
          )
        : null}
      {!isSSR && state.isOpen ? (
        <OverlayContainer
          className={`${props.overlayClassName} ulysse-prefix`}
          name="ulyssewidget"
        >
          <Popover
            {...props}
            ref={overlayRef}
            contentProps={mergeProps(overlayProps, positionProps)}
            isVisible={state.isOpen}
            state={state}
            onClose={() => {
              state.close()
              props.setIsFocused(false)
            }}
          />
        </OverlayContainer>
      ) : null}
    </>
  )
}

export default PopoverContainer
